import getWindow from './getWindow';
function isLocalEnv() {
  return getWindow().location.host.indexOf('local') === 0;
}
export default isLocalEnv;